import React from 'react';

export default function ValidCheck(props) {
  if (props.valid === true) return <span style={{ color: '#aaffaa' }}>✓</span>
  if (props.valid === false) return <span style={{ color: '#ffaaaa' }}>✕</span>
  return null;
}
